export default function IosGameControllerAOutline() {
  return (
    <div
      className="ion-icon-ios-game-controller-a-outline"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M194.822,240H160v-34.762c0-2.817-2.604-5.238-5.303-5.238h-22.145c-2.698,0-4.552,2.372-4.552,5.178V240H92.533
			c-2.615,0-4.533,2.143-4.533,4.771v21.427c0,2.698,2.031,5.803,4.861,5.803H128v35.467c0,2.615,2.143,4.533,4.771,4.533h21.427
			c2.698,0,5.803-2.031,5.803-4.861V272h34.762c2.817,0,5.238-2.604,5.238-5.303v-22.145C200,241.854,197.628,240,194.822,240z"/>
		<path d="M362.314,279.063c-10.736,0-19.451,8.515-19.451,19.153c0,10.555,8.715,19.084,19.451,19.084
			c10.783,0,19.498-8.529,19.498-19.084C381.812,287.578,373.098,279.063,362.314,279.063z"/>
		<path d="M319.766,237.165c-10.736,0-19.451,8.603-19.451,19.168c0,10.566,8.715,19.153,19.451,19.153
			c10.783,0,19.498-8.587,19.498-19.153C339.264,245.768,330.549,237.165,319.766,237.165z"/>
		<path d="M404.862,237.165c-10.729,0-19.442,8.603-19.442,19.168c0,10.566,8.714,19.153,19.442,19.153
			c10.737,0,19.452-8.587,19.452-19.153C424.314,245.768,415.6,237.165,404.862,237.165z"/>
		<path d="M362.314,195.301c-10.736,0-19.451,8.602-19.451,19.169c0,10.566,8.715,19.146,19.451,19.146
			c10.783,0,19.498-8.579,19.498-19.146C381.812,203.902,373.098,195.301,362.314,195.301z"/>
	</g>
	<path d="M369.269,162c25.838,0,49.704,9.314,67.204,26.229C454.225,205.386,464,229.247,464,255.418
		c0,26.303-9.806,50.405-27.611,67.869c-17.563,17.226-41.4,26.713-67.12,26.713H142.739c-25.712,0-49.548-9.487-67.117-26.715
		C57.81,305.818,48,281.717,48,255.418c0-26.167,9.78-50.028,27.539-67.188C93.043,171.315,116.909,162,142.739,162H369.269
		 M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529
		C430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146L369.269,146z"/>
</g>
</svg>
`,
      }}
    />
  )
}
